import logger from '../logger';

const useLocalStorage = key => {
  const getLocalStorage = () => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? item.split(', ') : [];
    } catch (error) {
      logger.error(`Failed to fetch local storage: ${error}`);
      return [];
    }
  };

  const setLocalStorage = valueToAdd => {
    try {
      const trimmedValue = valueToAdd.trim();
      if (!trimmedValue) {
        return;
      }

      const storedValues = getLocalStorage();
      const valueIndex = storedValues.indexOf(trimmedValue);

      if (valueIndex !== -1) {
        storedValues.splice(valueIndex, 1);
      }

      storedValues.unshift(trimmedValue);

      if (storedValues.length > 15) {
        storedValues.pop();
      }

      const newStoredValues = storedValues.join(', ');
      window.localStorage.setItem(key, newStoredValues);
    } catch (error) {
      logger.error(`Failed to set local storage: ${error}`);
    }
  };

  const removeLocalStorage = valueToRemove => {
    try {
      if (!valueToRemove) {
        window.localStorage.removeItem(key);
      } else {
        const storedValues = getLocalStorage();
        const newStoredValues = storedValues.filter(item => item !== valueToRemove).join(', ');
        if (newStoredValues) {
          window.localStorage.setItem(key, newStoredValues);
        } else {
          window.localStorage.removeItem(key);
        }
      }
    } catch (error) {
      logger.error(`Failed to remove item from local storage: ${error}`);
    }
  };

  return [getLocalStorage, setLocalStorage, removeLocalStorage];
};

export default useLocalStorage;
